// ═══ EvalInspectorPage 공용 상수/배지 ═══
// EvalInspectorPage / EvalInspectorCallDetail / EvalInspectorProfile에서 공유.
import React from 'react';

// API 베이스
// Phase 2: REACT_APP_API_BASE 우선, 빈 값이면 기존 동작 (window.location.origin / localhost)
var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
var _runtimeBase = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:4000';
export var API_BASE = _envBase || _runtimeBase;

// ─── 상수 ───
export var STATUS = {
  open:       { label: '콜 대기',  color: '#3B8BD4', bg: '#E6F1FB' },
  taken:      { label: '콜 수락',  color: '#1D9E75', bg: '#E1F5EE' },
  inspecting: { label: '검차중',   color: '#BA7517', bg: '#FAEEDA' },
  completed:  { label: '검차완료', color: '#534AB7', bg: '#EEEDFE' },
};

export var LEVELS = {
  '마스터': { color: '#D85A30', bg: '#FAECE7' },
  '시니어': { color: '#534AB7', bg: '#EEEDFE' },
  '일반':   { color: '#888780', bg: '#F1EFE8' },
};

// ─── 공통 컴포넌트 ───
export const Badge = ({ status }) => {
  const s = STATUS[status] || { label: status, color: '#888', bg: '#f0f0f0' };
  return <span style={{ padding: '3px 10px', borderRadius: 6, fontSize: 12, fontWeight: 600, color: s.color, background: s.bg }}>{s.label}</span>;
};

export const LvBadge = ({ level }) => {
  const c = LEVELS[level] || LEVELS['일반'];
  return <span style={{ padding: '2px 8px', borderRadius: 5, fontSize: 11, fontWeight: 600, color: c.color, background: c.bg }}>{level}</span>;
};

export const Stars = ({ value = 0, size = 16, onChange }) => (
  <span style={{ display: 'inline-flex', gap: 2 }}>
    {[1, 2, 3, 4, 5].map(i => (
      <span key={i} onClick={() => onChange?.(i)}
        style={{ fontSize: size, cursor: onChange ? 'pointer' : 'default', color: i <= value ? '#EF9F27' : '#D3D1C7', lineHeight: 1, WebkitTapHighlightColor: 'transparent' }}>★</span>
    ))}
  </span>
);

// #352 — null/undefined/''(미측정)만 회색. 0(정상)은 측정값으로 취급해 초록.
export const getPaintColor = v => (v === null || v === undefined || v === '') ? '#ccc' : v < 150 ? '#1D9E75' : v < 250 ? '#EF9F27' : '#E24B4A';
